import { t } from "i18n";
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { Toast } from "vant";
import { appToken } from "@/utils/util";
import { baseURL } from "./baseUrl";
import qs from "qs";
import axiosRetry from "axios-retry";

declare module "axios" {
  interface AxiosStatic {
    build(config?: AxiosRequestConfig): AxiosInstance;
  }
}

axiosRetry(axios, {
  retries: 2, // 设置自动发送请求次数
  retryDelay: retryCount => {
    return retryCount * 3000; // 重复请求延迟
  },
  shouldResetTimeout: true, //  重置超时时间
  retryCondition: error => {
    //true为打开自动发送请求，false为关闭自动发送请求
    if (error.message.includes("timeout")) {
      return true;
    } else {
      return false;
    }
  }
});
axios.defaults.timeout = 30000;

const useInterceptors = (axios: AxiosInstance) => {
  axios.interceptors.request.use(
    function (config) {
      if (config.url && config.url.includes("#loading")) {
        Toast.loading({
          duration: 0,
          message: t("src_api_request_26b5bd49"),
          forbidClick: true
        });
      }
      // 确保正确设置 Authorization header
      const authToken = config.headers?.Authorization ||
                        config.headers?.authorization ||
                        appToken();
      
      // 安全地设置 Authorization header，避免类型错误
      if (config.headers) {
        (config.headers as any).Authorization = authToken;
      } else {
        config.headers = { Authorization: authToken } as any;
      }
      return config;
    },
    function (error) {
      Toast(error.message || error);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      if (response.config.url && response.config.url.includes("#loading")) {
        Toast.clear();
      }
      return response;
    },
    function (error) {
      Toast(error.message || error);
      return Promise.reject(error);
    }
  );
};

axios.build = (config?: AxiosRequestConfig) => {
  const instance = axios.create(config);
  useInterceptors(instance);
  return instance;
};

Object.assign(axios.defaults, {
  baseURL: baseURL,
  "Content-Type": "application/json",
  transformRequest: [
    (data: any) => {
      return qs.stringify(data);
    }
  ]
});

useInterceptors(axios);

export default axios;
